import React, { useEffect, useMemo, useRef } from 'react';
import Lottie from 'lottie-react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { PURCHASE_STATES } from '../constants/purchaseStates';
import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion';
import animations from '../animations';
import './PurchaseLockAnimation.css';

const lottieNameByState = {
  [PURCHASE_STATES.LOCKED]: 'lock-idle',
  [PURCHASE_STATES.CHECKOUT_STARTING]: 'lock-combo',
  [PURCHASE_STATES.VERIFYING]: 'lock-combo',
  [PURCHASE_STATES.REDIRECTING]: 'lock-combo',
  [PURCHASE_STATES.UNLOCKED]: 'lock-combo',
};

const lottieSegmentByState = {
  [PURCHASE_STATES.CHECKOUT_STARTING]: [0, 36],
  [PURCHASE_STATES.VERIFYING]: [0, 36],
  [PURCHASE_STATES.REDIRECTING]: [0, 36],
  [PURCHASE_STATES.UNLOCKED]: [29, 200],
};

export default function PurchaseLockAnimation({
  state,
  reducedMotion: reducedMotionOverride,
  lottieSize,
  onAnimationComplete,
}) {
  const mediaPrefersReducedMotion = usePrefersReducedMotion();
  const reducedMotion = reducedMotionOverride ?? mediaPrefersReducedMotion;
  const lottieRef = useRef(null);
  const isSmall = useMediaQuery('(max-width:600px)');
  const animationKey = lottieNameByState[state];
  const animationData = animationKey ? animations[animationKey] : null;
  const segment = lottieSegmentByState[state];
  const resolvedLottieSize = useMemo(() => {
    if (typeof lottieSize === 'number') return lottieSize;
    return isSmall ? 180 : 250;
  }, [isSmall, lottieSize]);

  useEffect(() => {
    if (!lottieRef.current || !segment) return;
    lottieRef.current.playSegments(segment, true);
  }, [segment, state]);

  return (
    <div
      className={[
        'purchase-lock-animation',
        `purchase-lock-animation--${state}`,
        reducedMotion ? 'purchase-lock-animation--reduced' : '',
      ].join(' ').trim()}
      aria-live="polite"
    >
      {animationData && (
        <div style={{ width: resolvedLottieSize, height: resolvedLottieSize }}>
          <Lottie
            lottieRef={lottieRef}
            animationData={animationData}
            loop={
              !reducedMotion &&
              (state === PURCHASE_STATES.LOCKED ||
                state === PURCHASE_STATES.CHECKOUT_STARTING ||
                state === PURCHASE_STATES.VERIFYING ||
                state === PURCHASE_STATES.REDIRECTING)
            }
            autoplay={!reducedMotion}
            onComplete={() => {
              if (state === PURCHASE_STATES.UNLOCKED && typeof onAnimationComplete === 'function') {
                onAnimationComplete();
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
